
import DocView from "./docview"

const UseAgents = () =>{



    return(
    
        <div className="h-full w-full">
            <DocView />
        {/* <div className="w-1/6 card p-4">
             
        </div> */}
        {/* <div className=" p-2">
            <div className="flex flex-row h-full border-2 border-gray-300 bg-white rounded-lg">
                <div className=" w-4/6 h-full card p-4 ">
               
                </div> 
                <div className="w-full flex flex-row h-full border-s-2 border-gray-300 card p-4">
                 <DocView />
                </div>
            </div>
        </div> */}
    </div>
    
    )
}

export default UseAgents